import styled from 'styled-components';
import { colors, colorAliases } from '../../../../variables/colors.js';
import { fonts } from '../../../../variables/fonts.js';

var HotelHitConceptRow = styled.div.withConfig({
  displayName: "hotelHitConceptRow__HotelHitConceptRow",
  componentId: "sc-1vodp6a-0"
})(["align-items:center;background:", ";box-shadow:0 0 1px ", ";color:", ";display:flex;font-family:", ";font-size:14px;padding:8px;"], colors.sand, colorAliases.shadow, colors.almostblack, fonts.bold);

export { HotelHitConceptRow };
//# sourceMappingURL=hotelHitConceptRow.js.map
